import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanCreateTemplate(loggedInUser) {
    const allowedRoles = [Role.MANAGER, Role.ADMIN];
    return allowedRoles.indexOf(loggedInUser.role) >= 0;
}
export default CanCreateTemplate;